<template>
  <b-row
    align-v="center"
    @mouseover="setContextOnHover(contextHelpRoot+'Current')"
    @mouseleave="setContextOnHover(contextHelpRoot+'Current')"
  >
    <b-col class="m-0">
      <p class="label">
        {{ axis }}-axis (Current)
      </p>
    </b-col>
    <b-col class="m-0">
      <SimpleDropdownConfiguration :controller="InputCurrent" />
    </b-col>
    <b-col class="m-0">
      <SimpleDropdownConfiguration :controller="OutputCurrent" />
    </b-col>
    <b-col class="m-0">
      <CheckBoxConfiguration
        :controller="Log_axis"
        :switchprop="true"
      />
    </b-col>
  </b-row>
</template>

<script>
import {comboBoxConfCtrller, checkBoxGraphConfCtrller} from '@/assets/classes/configuration.js'
import SimpleDropdownConfiguration from '../elements/SimpleDropdownConfiguration'
import CheckBoxConfiguration from '../elements/CheckBoxConfiguration'
import { TypeAxis, ConfigName } from '@/common/plotDefinitions.js'
import { mapActions } from 'vuex'

const contextHelpRoot='ReportViewer/Units/'
export default {
  name: 'CurrentConfiguration',
  components: { 
    SimpleDropdownConfiguration,
    CheckBoxConfiguration
  },
  props: {
    axis:{
      type:String,
      required:true
    },
    sectionconfig:{
      type:String,
      required: true
    }
  },
  data () {
    return {
      InputCurrent: new comboBoxConfCtrller(TypeAxis.current.inputConfig,
        [
          {text:'A',value:0},
          {text:'mA',value:-3},
          {text:'μA',value:-6},
          {text:'nA',value:-9},
          {text:'pA',value:-12}
        ],'Input Current',2,`${contextHelpRoot}InputCurrent`,true),
      OutputCurrent:  new comboBoxConfCtrller(TypeAxis.current.outputConfig,
        [
          {text:'A',value:0},
          {text:'mA',value:-3},
          {text:'μA',value:-6},
          {text:'nA',value:-9},
          {text:'pA',value:-12}
        ],'Output Current',2,`${contextHelpRoot}OutputCurrent`,true),
      elementsConfig:[],
      Log_axis: new checkBoxGraphConfCtrller(`${ConfigName.BaseAxisProperties}.LOG{0}_BOOL`,'',false,contextHelpRoot+'Log_axis'),
      contextHelpRoot
    }
  },
  mounted(){
    this.elementsConfig=[
      this.InputCurrent,
      this.OutputCurrent,
      this.Log_axis
    ]
    this.Log_axis.formatKeyValue(this.axis)
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.setParent(this))
  },
  methods:mapActions(['setContextOnHover','setConfigReportModifiedReportViewer']),
}
</script>

<style lang="scss" scoped>
.label{
  margin:0px;
  font-size: 0.8rem;
}

.header{
  font-weight: bold;
  font-size: 0.9rem;
  margin-bottom: 0.35rem;
}
::v-deep .label-input-text{
  font-size: 0.8rem;
}
</style>
